// What the signed-in person may open. Owners (and admins) see everything; an employee sees the
// sections and accounts its owner opened (profile.team from /api/me). The server enforces the
// same rules; this only keeps closed sections out of the menus.

const RANK = { none: 0, view: 1, edit: 2 };

// Marketplace screen tab (MP_SECTIONS key) -> team section; null = owner only.
export const TAB_SECTION = { '': 'analytics', reports: 'reports', costs: 'costs', stocks: 'stocks', calculator: 'calculator', promotions: 'analytics', connections: null };

export const isMember = (profile) => Boolean(profile?.team?.member);

export function can(profile, section, level = 'view') {
  if (!isMember(profile)) return true;
  if (!section) return false;
  return (RANK[profile.team.permissions?.[section]] || 0) >= RANK[level];
}

export const canTab = (profile, key) => (isMember(profile) ? can(profile, TAB_SECTION[key]) : true);

// Weekly WB reports live under «Отчёты» but are read through reconciliation (analytics or reports).
export const canWeekly = (profile) => can(profile, 'reports') || can(profile, 'analytics');
